import { useEffect } from 'react'
import { Checkbox } from '@progress/kendo-react-inputs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Tooltip } from '@progress/kendo-react-tooltip'
import RangeDatePickerHL from '../rangePickerHL/rangeDatePickerHL.pure'
import RangeTimePickerHL from '../rangePickerHL/rangeTimePickerHL.pure'

// Mismos colores que las gráficas de sentimiento (SentimentDailyGraph / usage.view.js):
// verde = positivo, amarillo = neutral, rojo = negativo, gris = sin clasificar.
const SENTIMENT_COLOR = { positive: '#69B75C', neutral: '#FACC15', negative: '#EF4444', unclassified: '#9CA3AF' }
const SENTIMENT_IDS = ['positive', 'negative', 'neutral', 'unclassified']
// El dropdown de usuarios solo tiene sentido cuando se filtra por una conversación ya gestionada.
const STATUSES_THAT_UNLOCK_USER_FILTER = ['attended', 'resolved']

const AdvancedSearchFilters = ({ t, filterDraft, handleFilterChange, handleToggleSentiment, statusCatalog = [], handleToggleHistoryStatus, usersCatalog = [], applyFilters, clearFilters }) => {
  const userOptions = [{ text: t('usersFilterPlaceholder'), value: null }, ...usersCatalog]
  const isUserFilterEnabled = STATUSES_THAT_UNLOCK_USER_FILTER.some(status => filterDraft.historyStatuses.includes(status))
  const selectedUserOption = userOptions.find(option => option.value === filterDraft.userId) || userOptions[0]

  useEffect(() => {
    if (!isUserFilterEnabled && filterDraft.userId !== null) {
      handleFilterChange('userId', null)
    }
  }, [isUserFilterEnabled])

  return (
    <div className="advanced-search-panel">
      <div className="advanced-search-row">
        <div className="advanced-search-field">
          <label>{t('dateRange')}</label>
          <RangeDatePickerHL
            value={{ start: filterDraft.dateStart, end: filterDraft.dateEnd }}
            placeholder={t('dateRangePlaceholder')}
            onChange={(range) => {
              handleFilterChange('dateStart', range.start)
              handleFilterChange('dateEnd', range.end)
            }}
          />
        </div>
        <div className="advanced-search-field">
          <label>{t('timeRange')}</label>
          <RangeTimePickerHL
            value={{ start: filterDraft.timeStart, end: filterDraft.timeEnd }}
            placeholder={t('timeRangePlaceholder')}
            labelStart={t('timeStart')}
            labelEnd={t('timeEnd')}
            onChange={(range) => {
              handleFilterChange('timeStart', range.start)
              handleFilterChange('timeEnd', range.end)
            }}
          />
        </div>
        <div className="advanced-search-field advanced-search-sentiments">
          <label>{t('sentimentFilterTitle')}</label>
          <div className="advanced-search-sentiments-list">
            {SENTIMENT_IDS.map(id => (
              <label key={id} className="advanced-search-sentiment-item">
                <Checkbox
                  checked={filterDraft.sentiments.includes(id)}
                  onChange={() => handleToggleSentiment(id)}
                />
                <span className="advanced-search-sentiment-dot" style={{ backgroundColor: SENTIMENT_COLOR[id] }} />
                <span>{t(`sentiment.${id}`)}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="advanced-search-row">
        <div className="advanced-search-field advanced-search-users">
          <label>{t('usersFilterTitle')}</label>
          <Tooltip anchorElement="target" position="top" openDelay={300} parentTitle>
            <div title={t('usersFilterTooltip')}>
              <DropDownList
                id="historyUserFilter"
                name="historyUserFilter"
                className="eticket-dropdown-field"
                textField="text"
                dataItemKey="value"
                data={userOptions}
                value={selectedUserOption}
                onChange={(e) => handleFilterChange('userId', e.value.value)}
                disabled={!isUserFilterEnabled}
              />
            </div>
          </Tooltip>
        </div>
        <div className="advanced-search-field advanced-search-statuses">
          <label>{t('historyStatusFilterTitle')}</label>
          <div className="advanced-search-status-list">
            {statusCatalog.map(id => (
              <label key={id} className="advanced-search-status-item">
                <Checkbox
                  checked={filterDraft.historyStatuses.includes(id)}
                  onChange={() => handleToggleHistoryStatus(id)}
                />
                <span>{t(`historyStatus.${id}`)}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="advanced-search-actions">
        <button className="advanced-search-apply" onClick={applyFilters}>{t('applyFilters')}</button>
        <button className="advanced-search-clear" onClick={clearFilters}>{t('clearFilters')}</button>
      </div>
    </div>
  )
}

export default AdvancedSearchFilters
